import React, { useState } from 'react';
import { Edit, ChevronLeft, Search, Filter } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Message {
  id: string;
  name: string;
  avatar: string;
  lastMessage: string;
  time: string;
  unreadCount?: number;
  isOnline?: boolean;
}
const ACTIVE_USERS = [{
  id: '1',
  name: 'Marek',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marek'
}, {
  id: '2',
  name: 'Emilia',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emilia'
}, {
  id: '3',
  name: 'Kaupo',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Kaupo'
}, {
  id: '4',
  name: 'Andres',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Andres'
}, {
  id: '5',
  name: 'Sofia',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sofia'
}];
const ALL_MESSAGES: Message[] = [{
  id: '1',
  name: 'Hei!',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Hei',
  lastMessage: 'How are you?',
  time: '15 min',
  unreadCount: 1,
  isOnline: true
}, {
  id: '2',
  name: 'Hello!',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Hello',
  lastMessage: 'Kas kõik saavad lisada töökuulutusi, vaadata kandidaate.',
  time: '36 min',
  isOnline: true
}, {
  id: '3',
  name: 'Hei!',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Hei2',
  lastMessage: 'Im intresting you offer.',
  time: '39 min'
}, {
  id: '4',
  name: 'Tere!',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Tere',
  lastMessage: 'Kui pikk on töö aeg ?',
  time: '50 min'
}, {
  id: '5',
  name: 'Hei!',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Hei3',
  lastMessage: 'Kas võib tulla olete objektil?',
  time: '57 min'
}, {
  id: '6',
  name: 'Väga meeldiv!',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Vaga',
  lastMessage: 'Super korralik.',
  time: '59 min'
}];
type FilterType = 'all' | 'unread' | 'archived';
export function MessagesPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState<FilterType>('all');
  const [showFilters, setShowFilters] = useState(false);
  const filteredMessages = ALL_MESSAGES.filter(msg => {
    const matchesSearch = msg.name.toLowerCase().includes(searchQuery.toLowerCase()) || msg.lastMessage.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = filter === 'all' || filter === 'unread' && msg.unreadCount || filter === 'archived' && false; // No archived messages in demo
    return matchesSearch && matchesFilter;
  });
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="min-h-screen bg-white dark:bg-gray-900 pb-24 transition-colors duration-200" data-id="element-150">
      {/* Header */}
      <motion.div initial={{
      y: -20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.4
    }} className="px-6 pt-12 pb-4 sticky top-0 bg-white dark:bg-gray-900 z-10 border-b border-gray-100 dark:border-gray-800" data-id="element-151">
        <div className="flex justify-between items-center mb-4" data-id="element-152">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-10 h-10 bg-[#00D084] rounded-xl flex items-center justify-center text-white shadow-md hover:bg-[#00B074] transition-colors" data-id="element-153">
            <ChevronLeft className="w-6 h-6" data-id="element-154" />
          </motion.button>
          <h1 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-155">
            Messages
          </h1>
          <motion.button whileHover={{
          scale: 1.05,
          rotate: 5
        }} whileTap={{
          scale: 0.95
        }} className="w-10 h-10 flex items-center justify-center text-[#00D084] hover:bg-green-50 dark:hover:bg-gray-800 rounded-xl transition-colors" data-id="element-156">
            <Edit className="w-6 h-6" data-id="element-157" />
          </motion.button>
        </div>

        {/* Search Bar */}
        <div className="flex gap-2 mb-4" data-id="element-158">
          <div className="flex-1 relative" data-id="element-159">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-160" />
            <motion.input whileFocus={{
            scale: 1.01
          }} type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search messages..." className="w-full pl-10 pr-4 py-2.5 bg-gray-100 dark:bg-gray-800 rounded-xl text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#00D084] transition-all" data-id="element-161" />
          </div>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => setShowFilters(!showFilters)} className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${showFilters ? 'bg-[#00D084] text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400'}`} data-id="element-162">
            <Filter className="w-5 h-5" data-id="element-163" />
          </motion.button>
        </div>

        {/* Filter Pills */}
        <AnimatePresence data-id="element-164">
          {showFilters && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} className="flex gap-2 overflow-hidden" data-id="element-165">
              {(['all', 'unread', 'archived'] as FilterType[]).map(f => <motion.button key={f} whileTap={{
            scale: 0.95
          }} onClick={() => setFilter(f)} className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors ${filter === f ? 'bg-[#00D084] text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400'}`} data-id="element-166">
                  {f.charAt(0).toUpperCase() + f.slice(1)}
                </motion.button>)}
            </motion.div>}
        </AnimatePresence>
      </motion.div>

      {/* Active Users */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="px-6 py-4 border-b border-gray-100 dark:border-gray-800" data-id="element-167">
        <h2 className="text-sm font-bold text-gray-900 dark:text-white mb-4" data-id="element-168">
          Active
        </h2>
        <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide -mx-6 px-6" data-id="element-169">
          {ACTIVE_USERS.map((user, index) => <motion.div key={user.id} initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3 + index * 0.05
        }} whileHover={{
          scale: 1.05
        }} className="flex flex-col items-center gap-2 min-w-[64px] cursor-pointer" data-id="element-170">
              <div className="w-16 h-16 rounded-full p-0.5 border-2 border-[#00D084]" data-id="element-171">
                <img src={user.avatar} alt={user.name} className="w-full h-full rounded-full object-cover bg-gray-100 dark:bg-gray-800" data-id="element-172" />
              </div>
              <span className="text-xs text-gray-600 dark:text-gray-400 font-medium" data-id="element-173">
                {user.name}
              </span>
            </motion.div>)}
        </div>
      </motion.div>

      {/* Chat List */}
      <div className="px-6 mt-4" data-id="element-174">
        <div className="flex justify-between items-center mb-4" data-id="element-175">
          <h2 className="text-sm font-bold text-gray-900 dark:text-white" data-id="element-176">
            Chat List
            {filteredMessages.length !== ALL_MESSAGES.length && <span className="ml-2 text-xs font-normal text-gray-500 dark:text-gray-400" data-id="element-177">
                ({filteredMessages.length} of {ALL_MESSAGES.length})
              </span>}
          </h2>
        </div>

        {filteredMessages.length === 0 ? <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center py-12" data-id="element-178">
            <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-179">
              <Search className="w-8 h-8 text-gray-400" data-id="element-180" />
            </div>
            <p className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-181">
              No messages found
            </p>
          </motion.div> : <div className="space-y-6" data-id="element-182">
            <AnimatePresence data-id="element-183">
              {filteredMessages.map((chat, index) => <motion.div key={chat.id} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 20
          }} transition={{
            delay: index * 0.05
          }} whileHover={{
            x: 4
          }} className="flex gap-4 group cursor-pointer" data-id="element-184">
                  <div className="relative" data-id="element-185">
                    <div className="w-14 h-14 rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden" data-id="element-186">
                      <img src={chat.avatar} alt={chat.name} className="w-full h-full object-cover" data-id="element-187" />
                    </div>
                    {chat.isOnline && <motion.div animate={{
                scale: [1, 1.2, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity
              }} className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-[#00D084] border-2 border-white dark:border-gray-900 rounded-full" data-id="element-188" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-189">
                    <div className="flex justify-between items-baseline mb-1" data-id="element-190">
                      <h3 className="font-bold text-gray-900 dark:text-white truncate" data-id="element-191">
                        {chat.name}
                      </h3>
                      <span className={`text-xs ${chat.unreadCount ? 'text-[#00D084] font-bold' : 'text-gray-400 dark:text-gray-500'}`} data-id="element-192">
                        {chat.time}
                      </span>
                    </div>
                    <div className="flex justify-between items-start" data-id="element-193">
                      <p className={`text-sm truncate pr-4 ${chat.unreadCount ? 'text-gray-900 dark:text-white font-medium' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-194">
                        {chat.lastMessage}
                      </p>
                      {chat.unreadCount && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  type: 'spring',
                  stiffness: 500,
                  damping: 15
                }} className="w-5 h-5 bg-[#00D084] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-195">
                          <span className="text-[10px] font-bold text-white" data-id="element-196">
                            {chat.unreadCount}
                          </span>
                        </motion.div>}
                    </div>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </div>}
      </div>
    </motion.div>;
}